import React, { lazy, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import './video.styles.css';
import ControlBar from './controls/controlBar';
import PlayPauseBig from './controls/playPauseBig';
import ReplayButtonBig from './controls/replayButtonBig';
import { logDebugging } from '../../log/logger';
import * as STATES from '../../core/states/player.states';
import YoutubeComponent from './youtubeComponent';
import SimplePlaylist from '../playlists/simplePlaylist';
import OverlayComponent from './overlay/overlayComponent';
import { VIDEO_TYPE } from '../../utils/urlVideoUtils';
import ShareButton from '../social/ShareButton';
import Spinner from '../../ads/components/controls/ad.loading';

const PlaylistModal = lazy(() =>
  import(/* webpackChunkName: "PlaylistModal" */ '../playlists/PlaylistModal'),
);

export default function VideoPlayerComponent({ config, videoPlayer, playlistmodel }) {
  const [state, setState] = useState(videoPlayer.state);

  useEffect(() => {
    videoPlayer.loadVideo();
    videoPlayer.stateEvent.subscribe(() => {
      // const [typeEvent, stateName] = message.message;
      setState(videoPlayer.state);
    });
  }, [videoPlayer]);

  function handlerClick() {
    logDebugging('click videoProducer');
    if (!playlistmodel.videoProducerModel) return;
    const urlVideoProducer = playlistmodel.videoProducerModel.setMarkerSelectedBySec(
      videoPlayer.currentTime,
    );

    if (urlVideoProducer && state !== STATES.STANDBY && state !== STATES.STOPPED) {
      // eslint-disable-next-line no-undef
      window.open(urlVideoProducer, 'vidcrunchwindow');
    }
  }

  const controlBar = config.showControls ? (
    <ControlBar config={config} videoPlayer={videoPlayer} playlistmodel={playlistmodel} />
  ) : null;

  const simplyControlsClass = config.showControls ? '' : 'tpx-simply-controls';

  const showPlayPauseBig =
    state === STATES.STANDBY && !config.autoplay ? (
      <PlayPauseBig videoPlayer={videoPlayer} state={state} />
    ) : null;

  const showSpinner = state === STATES.LOADING ? <Spinner /> : null;

  const showReplay =
    state === STATES.STOPPED && !config.loop ? (
      <ReplayButtonBig videoPlayer={videoPlayer} playlistmodel={playlistmodel} />
    ) : null;
  const showControls =
    !showSpinner &&
    config.showControls &&
    videoPlayer.videoData?.typeFactory !== VIDEO_TYPE.YOUTUBE ? (
      <SimplePlaylist playlistmodel={playlistmodel} videoPlayer={videoPlayer} />
    ) : null;
  /* eslint-disable no-undef */
  const adSiplayed = document.getElementById(config.targetAdId).style.display === 'block';
  const socialMedia =
    config.showShare && (state === STATES.PAUSED || state === STATES.STOPPED) && !adSiplayed ? (
      <ShareButton />
    ) : null;

  const videoPoster = videoPlayer.videoData.isYoutube ? null : videoPlayer.videoData.thumb;
  return (
    <>
      <div
        id="video-player-container"
        className={`tpx-video-player-container ${state.toLowerCase()} ${simplyControlsClass} ${videoPlayer.videoData?.typeFactory?.toLowerCase()}`}
        onClick={handlerClick}
      >
        {socialMedia}
        {showSpinner}
        {showPlayPauseBig}
        {showReplay}

        <video
          id={videoPlayer.videoData.idVideoElement}
          className="tpx-video-element"
          playsInline
          src=""
          // ref={videoPlayer}
          autoPlay={config.autoplay}
          muted={config.muted || config.autoplay}
          poster={videoPoster}
        />
        <YoutubeComponent state={state} videoPlayer={videoPlayer} />
        <OverlayComponent />
        {playlistmodel.isPlaylist && (
          <PlaylistModal
            state={state}
            config={config}
            videoPlayer={videoPlayer}
            playlistmodel={playlistmodel}
          />
        )}
        {controlBar}
      </div>
      {showControls}
    </>
  );
}

VideoPlayerComponent.propTypes = {
  showPlaylistModal: PropTypes.bool,
  config: PropTypes.object.isRequired,
  videoPlayer: PropTypes.object.isRequired,
  playlistmodel: PropTypes.object.isRequired,
};
